import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
import { serviceName } from '../service.js';
export const TarpulatorEntityTypeNameSchema = z.enum(['region', 'vendorRates']);
export const TarpulatorEntityTypeName = TarpulatorEntityTypeNameSchema.enum;
export const serviceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const TarpulatorServiceEventBaseSchema = EventBaseSchema.extend(z.object({
    type: serviceEventType(),
}).shape);
